import axios from '../axios'
import {
    AWARD_LIST_REQUEST, AWARD_LIST_SUCCESS, AWARD_LIST_FAIL,
    AWARD_DETAILS_REQUEST, AWARD_DETAILS_SUCCESS, AWARD_DETAILS_FAIL,
    AWARD_CREATE_REQUEST, AWARD_CREATE_SUCCESS, AWARD_CREATE_FAIL,
    AWARD_UPDATE_REQUEST, AWARD_UPDATE_SUCCESS, AWARD_UPDATE_FAIL,
    AWARD_DELETE_REQUEST, AWARD_DELETE_SUCCESS, AWARD_DELETE_FAIL,
} from '../constants/awardConstants'


const authHeader = (userInfo) => ({
    headers: { Authorization: `Bearer ${userInfo.token}` }
})

const multipartHeader = (userInfo) => ({
    headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'multipart/form-data',
    }
})


export const listAwards = () => async (dispatch, getState) => {
    try {
        dispatch({ type: AWARD_LIST_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.get('/api/awards/', authHeader(userInfo))
        dispatch({ type: AWARD_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: AWARD_LIST_FAIL, payload: error.response?.data?.detail || error.message })
    }
}


export const getAwardDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: AWARD_DETAILS_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.get(`/api/awards/${id}/`, authHeader(userInfo))
        dispatch({ type: AWARD_DETAILS_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: AWARD_DETAILS_FAIL, payload: error.response?.data?.detail || error.message })
    }
}


export const createAward = (formData) => async (dispatch, getState) => {
    try {
        dispatch({ type: AWARD_CREATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.post('/api/awards/create/', formData, multipartHeader(userInfo))
        dispatch({ type: AWARD_CREATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: AWARD_CREATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}


export const updateAward = (id, formData) => async (dispatch, getState) => {
    try {
        dispatch({ type: AWARD_UPDATE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        const { data } = await axios.put(`/api/awards/update/${id}/`, formData, multipartHeader(userInfo))
        dispatch({ type: AWARD_UPDATE_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: AWARD_UPDATE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}


export const deleteAward = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: AWARD_DELETE_REQUEST })
        const { userLogin: { userInfo } } = getState()
        await axios.delete(`/api/awards/delete/${id}/`, authHeader(userInfo))
        dispatch({ type: AWARD_DELETE_SUCCESS })
    } catch (error) {
        dispatch({ type: AWARD_DELETE_FAIL, payload: error.response?.data?.detail || error.message })
    }
}
